import { render, staticRenderFns } from "./targets-modal.vue?vue&type=template&id=d5632562"
import script from "./targets-modal.vue?vue&type=script&lang=js"
export * from "./targets-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports